<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout row wrap>
                    <v-flex xs6>
                    <v-stepper v-model="e1">
                        <v-stepper-header>
                            <v-stepper-step :complete="e1 > 1" step="1">Step 1</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step :complete="e1 > 2" step="2">Step 2</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="3">Step 3</v-stepper-step>
                        </v-stepper-header>

                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-select v-model="booking.bookingType" :items="bookingType" label="Booking Type" ></v-select>
                                <v-dialog ref="bookingDateDialog" v-model="bookingDateModal" :return-value.sync="booking.bookingDate" persistent lazy full-width width="290px">
                                    <v-text-field slot="activator" v-model="booking.bookingDate" label="Booking Date" append-icon="event" readonly></v-text-field>
                                    <v-date-picker v-model="booking.bookingDate" :allowed-dates="allowedDates" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="bookingDateModal = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="handleBookingDate">OK</v-btn>
                                    </v-date-picker>
                                </v-dialog>
                                <v-text-field v-model="booking.contact" label="Contact Name" clearable></v-text-field>
                                <v-text-field v-model="booking.club" label="Club" clearable></v-text-field>
                                <v-text-field v-model="booking.clientRef" label="Client Reference" clearable></v-text-field>

                                <v-flex xs12 class="text-xs-right pa-0">
                                    <v-btn class="ma-0" color="primary" @click="e1 = 2" :disabled="validateStep1">
                                        Continue
                                    </v-btn>
                                </v-flex>
                            </v-stepper-content>

                            <v-stepper-content step="2">
                                <v-text-field v-model="booking.email" label="Email Address" clearable></v-text-field>
                                <v-text-field v-model="booking.phone" label="Phone Number" clearable></v-text-field>
                                <v-text-field v-model="booking.address1" label="Address 1"></v-text-field>
                                <v-text-field v-model="booking.address2" label="Address 2"></v-text-field>
                                <v-text-field v-model="booking.city" label="City"></v-text-field>
                                <v-text-field v-model="booking.postcode" label="Postcode"></v-text-field>

                                <v-flex xs12 class="text-xs-right pa-0">
                                    <v-btn color="primary" @click="e1 = 1">
                                        Back
                                    </v-btn>
                                    <v-btn class="ma-0" color="primary" @click="e1 = 3" :disabled="validateStep2">
                                        Continue
                                    </v-btn>
                                </v-flex>
                            </v-stepper-content>

                            <v-stepper-content step="3">
                                <v-data-table v-if="e1 == 3" :headers="groupTicketHeaders" :items="groupTicketPrices" hide-actions>
                                    <template v-slot:items="props">
                                        <td class="text-xs-left">{{ props.item.name }}</td>
                                        <td>
                                            <v-slider class="pt-2" v-model="booking.tickets[props.item.value+'Qty']" :id="props.index" :min="0" :max="10" :step="1" thumb-label="always" :thumb-size="20" @change="sumTickets(props, booking.tickets[props.item.value+'Qty'])"></v-slider>
                                        </td>
                                        <td class="text-xs-center">{{ new Intl.NumberFormat('en-US', {style: 'currency', currency: 'GBP', minimumFractionDigits: 2}).format(props.item.price) }}</td>
                                        <td v-if="booking.tickets[props.item.value+'Price']">{{ new Intl.NumberFormat('en-US', {style: 'currency', currency: 'GBP', minimumFractionDigits: 2}).format(booking.tickets[props.item.value+'Price']) }}</td>
                                        <td v-else>£0.00</td>
                                    </template>
                                    <template v-slot:footer>
                                        <td :colspan="groupTicketHeaders.length" class="text-xs-right">
                                            <strong>Total: {{ new Intl.NumberFormat('en-US', {style: 'currency', currency: 'GBP', minimumFractionDigits: 2}).format(booking.tickets.totalPrice) }}</strong>
                                        </td>
                                    </template>
                                </v-data-table>

                                <v-flex xs12 class="text-xs-right pa-0">
                                    <v-btn color="primary" @click="e1 = 1">
                                        Back
                                    </v-btn>
                                    <v-btn class="ma-0" color="primary" @click="e1 = 4" :disabled="validateStep2">
                                        Continue
                                    </v-btn>
                                </v-flex>    
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template> 

<script>
  import sweetAlert from '../sweetAlert.js';
  import axios from 'axios';
  import moment from 'moment';

  export default {
    data () {
      return {
        booking: {
            bookingDate: new Date().toISOString().substr(0, 10),
            tickets: {
                totalPrice: 0.00
            }
        },
        bookingType: [{ value: 'matchTicket', text: 'Match Ticket' },
                      { value: 'seasonTicket', text: 'Season Ticket' },
                      { value: 'groupTicket', text: 'Group Ticket'}],
        bookingDateModal: false,
        e1: 0,
        groupTicketPrices: [{ name: 'Group Adult', price: 40.00, value: 'groupAdult', qty: 0 },
                            { name: 'Group Concession', price: 35.00, value: 'groupConcession', qty: 0 },
                            { name: 'Group Under 16', price: 30.00, value: 'groupUnder16', qty: 0 },
                            { name: 'Group Under 11', price: 25.00, value: 'groupUnder11', qty: 0 },
                            { name: 'Free Carer', price: 10.00, value: 'freeCarer', qty: 0 },
                            { name: 'Coach Adult', price: 25.00, value: 'coachAdult', qty: 0 },
                            { name: 'Coach Junior', price: 15.00, value: 'coachJunior', qty: 0 },
                            { name: 'Parking', price: 25.00, value: 'parking', qty: 0 }],
        groupTicketHeaders: [{ text: 'Ticket Type', align: 'left', sortable: false },
                             { text: 'Quantity', align: 'left', sortable: false },
                             { text: 'Ticket Price', align: 'center', sortable: false },
                             { text: 'Total', align: 'center', sortable: false }],
        resultCodesSuccess: ['000.000.000', '000.000.100', '000.100.110', '000.100.111', '000.100.112', '000.300.000', '000.300.100', '000.300.101', '000.300.102', '000.600.000'],
        resultCodesManuallyReview: ['000.400.000', '000.400.010', '000.400.020', '000.400.040', '000.400.050', '000.400.060', '000.400.070', '000.400.080', '000.400.090', '000.400.100'],
        resultCodesPending: ['000.200.000', '000.200.100', '000.200.101', '000.200.102', '000.200.200', '100.400.500', '800.400.500', '800.400.501', '800.400.502'],
      }
    },
    components: {
      
    },
    mixins: [ sweetAlert ],
    beforeMount() {
     
    },
    computed: {
        validateStep1() {
            if(!this.booking.contact || !this.booking.club || !this.booking.clientRef) {
                return true;
            }
            else {
                return false;
            }
        },
        validateStep2() {

        },

    },
    methods: {
        getPaymentStatusPath() {
            this.resourcePath = decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent('resourcePath').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
            this.getPaymentStatus();
        },
        getPaymentStatus() {
            if(this.resourcePath.includes('/v1/checkouts/')) {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-payment-status',
                data: { resourcePath: this.resourcePath },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response.data);
                    this.sweetAlert(response.data);
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getAddresses() {
            axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-addresses',
                data: { resourcePath: this.resourcePath },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.addresses = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
        allowedDates: val => val > moment().subtract(1, "days").format('YYYY-MM-DD'),
        handleBookingDate() {
            this.$refs.bookingDateDialog.save(this.booking.bookingDate);
            this.bookingDateModal = false;
        },
        sumTickets(props, qty) {
            this.booking.tickets[props.item.value+'Price'] = props.item.price * qty;
            this.booking.tickets.totalPrice += props.item.price;
            console.log(this.booking.tickets);
            let total = 0;

            Object.keys(this.booking.tickets).forEach(item => {
                
                if(item.includes('Price') && item != 'totalPrice') {
                    console.log(item + ': ' + this.booking.tickets[item]);
                    
                    total += parseFloat(this.booking.tickets[item]);
                    
                }
                console.log(total);
            });
            this.booking.tickets.totalPrice = total;
        }
    },
}
</script>

<style>
    .ticket-prices {
        color: rgba(0,0,0,.54);
    }
</style>
